import { gql } from '@apollo/client';

export default gql`
  query storesSelect {
    stores {
      id
      name
    }
  }
`;
